import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { AddEditDealerModal, AddEditLocationModal, DMSv3SettingsTable } from "modules/DMSv3/Settings/components";
import "modules/DMSv3/Settings/DMSv3SettingsDashboard.scss";

import type { DealerDMS, DealerLocation } from "models";

export const Settings = () => {
  const [selectedDealer, setSelectedDealer] = useState<DealerDMS | undefined>(undefined);
  const [isAddEditDealerModalOpen, setIsAddEditDealerModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<DealerLocation | undefined>(undefined);
  const [selectedLocationDealer, setSelectedLocationDealer] = useState<DealerDMS | undefined>(undefined);
  const [isAddEditLocationModalOpen, setIsAddEditLocationModalOpen] = useState(false);

  const handleSelectDealer = (dealer?: DealerDMS) => {
    setSelectedDealer(dealer);
    setIsAddEditDealerModalOpen(true);
  };

  const handleCloseAddEditDealerModal = () => {
    setSelectedDealer(undefined);
    setIsAddEditDealerModalOpen(false);
  };

  const handleSelectLocation = (location: DealerLocation | null) => {
    setSelectedLocation(location ?? undefined);
    setIsAddEditLocationModalOpen(true);
  };

  const handleCloseAddEditLocationModal = () => {
    setSelectedLocation(undefined);
    setSelectedLocationDealer(undefined);
    setIsAddEditLocationModalOpen(false);
  };

  return (
    <div className="DMSv3SettingsDashboard">
      <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.DMSv3SettingDealers}>
        <div className="toolbar">
          <Button basic icon className="add-btn" onClick={() => handleSelectDealer()}>
            <Icon className="plus" />
          </Button>
        </div>
      </Can>
      <DMSv3SettingsTable
        onSelectDealer={handleSelectDealer}
        onSelectLocation={handleSelectLocation}
        onSelectLocationDealer={dealer => setSelectedLocationDealer(dealer)}
      />
      <AddEditDealerModal isOpen={isAddEditDealerModalOpen} selectedDealer={selectedDealer} onClose={handleCloseAddEditDealerModal} />
      <AddEditLocationModal
        isOpen={isAddEditLocationModalOpen}
        onClose={handleCloseAddEditLocationModal}
        selectedLocation={selectedLocation}
        selectedLocationDealer={selectedLocationDealer}
      />
    </div>
  );
};
